import React, { useRef, useCallback } from "react";
import styles from "../GeniusRegistrationModal.module.css";

export const OtpDigitInput = ({ value = "", onChange, error = false, disabled = false }) => {
  const inputsRef = useRef([]);
  const digits = (value || "").padEnd(4, " ").slice(0, 4).split("");

  const emit = useCallback(
    (nextDigits) => {
      onChange(nextDigits.join("").replace(/\s/g, "").slice(0, 4));
    },
    [onChange]
  );

  const handleChange = (index, raw) => {
    const digit = raw.replace(/\D/g, "").slice(-1);
    const next = [...digits.map((d) => (d === " " ? "" : d))];
    next[index] = digit;
    emit(next);
    if (digit && index < 3) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !digits[index]?.trim() && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 4);
    if (!pasted) return;
    emit(pasted.split(""));
    const focusIndex = Math.min(pasted.length, 3);
    inputsRef.current[focusIndex]?.focus();
  };

  return (
    <div className={`${styles.otpRow} ${error ? styles.otpRowError : ""}`}>
      {[0, 1, 2, 3].map((i) => (
        <input
          key={i}
          ref={(el) => {
            inputsRef.current[i] = el;
          }}
          type="text"
          inputMode="numeric"
          maxLength={1}
          className={styles.otpBox}
          value={digits[i]?.trim() ? digits[i] : ""}
          disabled={disabled}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
          aria-label={`OTP digit ${i + 1}`}
        />
      ))}
    </div>
  );
};
